export default "__VITE_ASSET__8a004550__"